<div class="container-fluid p-0">

  <div style="height: 500px; overflow: hidden; position: relative;">
    <div class="col-md-12">
      <div id="bannerCarousel" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active" style="height: 500px;">
            <img style="display: block; margin: auto; width: 100%; height: 500px; object-fit: contain;"
              src="../../assets/images/banner.jpg" alt="Banner 1">

          </div>
          <div class="carousel-item" style="height: 500px;">
            <img style="display: block; margin: auto; width: 100%; height: 500px; object-fit: contain;"
              src="../../assets/images/SocialMediaBanner.jpg" alt="Banner 2">

          </div>
        </div>
        <a class="carousel-control-prev" href="#bannerCarousel" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"
            style="filter: brightness(0) saturate(100%) invert(22%) sepia(24%) saturate(1812%) hue-rotate(191deg) brightness(90%) contrast(90%);"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#bannerCarousel" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"
            style="filter: brightness(0) saturate(100%) invert(22%) sepia(24%) saturate(1812%) hue-rotate(191deg) brightness(90%) contrast(90%);"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <div style="width: 100%;padding: 0px 20px;text-align: center;">
    <div>
      <span class="link-header">
        CloRent Factory are launching Application <span style="color: #203b72; font-size: 33px; font-weight: 600;">
          Intercity Agent</span>
        <br> Get Access to Direct owner Listing Verified Rental and Resale Listings <br>
        Property Listing, Lead Management, Project listing and Management
      </span>
    </div>
    <div style="margin-top: 10px;">
      <img class="app-logo" src="../../assets/images/android.png" alt="" (click)="openPlaystoreAgent()">

      <img class="app-logo" src="../../assets/images/apple.png" alt="" (click)="openAppstoreAgent()">
    </div>
  </div>

  <div style="text-align: start;border-top: 1px solid #203b72;">
    <h2 style="color: #203b72;font-weight: 600; font-size: 35px;margin-left: 25px;margin-top: 10px;">Application
      features</h2>
  </div>
  <div class="card-grid">
    <div class="card responsive-card" *ngFor="let card of cards; let i = index">
      <img [src]="card.image" [alt]="card.title" class="card-img" />
      <div class="card-content">
        <h3>{{card.title}}</h3>
        <ul>
          <li *ngFor="let item of card.description;">{{item}}</li>
        </ul>
      </div>
    </div>
  </div>

  <app-about-us></app-about-us>
<app-footer></app-footer>
 
  <a href="https://api.whatsapp.com/send?phone=917775028877&text=I would like to know more about “CloRent Factory“"
    target="_blank" class="float">
    <i class="fa fa-whatsapp my-float"></i>
  </a>
</div>